import type { InvestmentExposureEntry } from "@eu.mdotm.api/sphere";

/**
 * Market value (€) of an exposure bucket, from `InvestmentExposureEntry.value` (MDOT-25408). The
 * backend fills it for quantity portfolios and leaves it `null` otherwise.
 */

/** The widget shows market values for tag breakdowns only, and only when the payload carries some. */
export function hasMarketValue(
	firstLevel: "CUSTOM_TAG" | "RISK_MODEL",
	composition: ReadonlyArray<InvestmentExposureEntry> | undefined,
): boolean {
	return firstLevel === "CUSTOM_TAG" && (composition ?? []).some((entry) => entry.value != null);
}

/** Adds an entry's value to a running bucket total, cent-rounded; `undefined` until a value is seen. */
export function addMarketValue(total: number | undefined, value: number | null | undefined): number | undefined {
	if (value == null) {
		return total;
	}
	return Math.round(((total ?? 0) + value) * 100) / 100;
}
